// extracted by mini-css-extract-plugin
export default {"time-spent-image":"timeSpent_time-spent-image__ktbCo"};